<template>
  <nuttrema-layout-form-standard
     class="is-center-padding-top-1em"
    :edit="true"
    :saveError="InstanceSourceDetails.saveError">
    <template slot="center">
       <el-form
         label-width="20em"
         ref="source-details"
        :model="formData">

        <section>
          <div class="section-items">
            <el-collapse v-model="activeName" accordion>
              <el-collapse-item :title="$t('label.main_information')" name="1">
                <dl class="nuttrema-description-list--main-details">
                  <dt>{{ $t('label.name') }}</dt>
                  <dd>{{ _get(InstanceSourceDetails, 'data.name') }}</dd>
                  <dd class="desc">{{ _get(InstanceSourceDetails, 'data.title') }}</dd>

                  <dt>{{ $t('label.code') }}</dt>
                  <dd>{{ _get(InstanceSourceDetails, 'data.code') }}</dd>

                  <dt>{{ $t('label.includes') }}</dt>
                  <dd><span v-for="(item, index) in _get(InstanceSourceDetails, 'data.includes', [])"><template v-if="index !== 0">, </template>{{ item }}</span></dd>

                  <dt>{{ $t('label.version') }}</dt>
                  <dd>{{ _get(InstanceSourceDetails, 'data.version') }}, {{ _get(InstanceSourceDetails, 'data.year') | moment('LL') }}</dd>

                  <dt>{{ $t('label.source_type') }}</dt>
                  <dd>{{ _get(InstanceSourceDetails, 'data.SourceType.name') }}</dd>

                  <dt>{{ $t('label.url') }}</dt>
                  <dd><a :href="_get(InstanceSourceDetails, 'data.url')" target="_blank" no-fallow>{{ _get(InstanceSourceDetails, 'data.url') | slice }}</a></dd>

                  <dt>{{ $t('label.status') }}</dt>
                  <template v-if="_get(InstanceSourceDetails, 'data.active')">
                    <dd>{{ $t('label.preactivated') }}</dd>
                  </template>
                  <template v-else>
                    <dd>{{ _get(InstanceSourceDetails, 'data.active') ? $t('label.active') : $t('label.inactive') }}</dd>
                  </template>
                </dl>
              </el-collapse-item>
              <el-collapse-item :title="$t('label.region_and_language')" name="2">
                <dl class="nuttrema-description-list--main-details">
                  <dt>{{ $t('label.applicable_regions') }}</dt>
                  <dd><span v-for="(region, index) in _get(InstanceSourceDetails, 'data.ApplicableRegions', [])"><template v-if="index !== 0">, </template>{{ _get(region, 'name') }}</span></dd>

                  <dt>{{ $t('label.available_languages') }}</dt>
                  <dd><span v-for="(language, index) in _get(InstanceSourceDetails, 'data.AvailableLanguages', [])"><template v-if="index !== 0">, </template>{{ _get(language, 'name') }}</span></dd>
                </dl>
              </el-collapse-item>
              <el-collapse-item :title="$t('label.usage')" name="3">
                <dl class="nuttrema-description-list--main-details">
                  <dt>{{ $t('label.used') }}</dt>
                  <dd>{{ _get(InstanceSourceDetails, 'data.usage.used') ? $t('label.yes') : $t('label.no') }}</dd>

                  <template v-for="(usage, name) in _get(InstanceSourceDetails, 'data.usage.details', [])">
                    <dt>{{ $t(`label.${name}`) }}</dt>
                    <dd>{{ $t('label.usage_count') }}: <strong>{{ _get(usage, 'count', 0) }}</strong></dd>
                    <dd>{{ $t('label.recent') }}:
                      <template v-if="_isEmpty(usage.recent)">
                        {{ $t('label.no_recent_usage') }}
                      </template>
                      <template v-else>
                        <span v-for="(recent, index) in _get(usage, 'recent', [])">
                          <template v-if="index !== 0">, </template>{{ _get(recent, 'name') }}
                        </span>
                      </template>
                    </dd>
                  </template>
                </dl>
                </el-collapse-item>
              </el-collapse-item>
            </el-collapse>
          </div>

          <div class="section-help">
            <dl class="nuttrema-description-list--notes">
              <dt>{{ $t('label.notes') }}:</dt>
              <dd v-html="_markdown.renderInline($t('label.note_source_preactivated'))"></dd>
              <dd v-html="_markdown.renderInline($t('label.note_source_deactivate'))"></dd>
            </dl>
          </div>

        </section>
      </el-form>
    </template>

    <template slot="footer">
      <nav class="footer-row">

        <template v-if="_get(InstanceSourceDetails, 'data.toggle_active.allowed')">
          <el-button type="primary"
             size="small"
            :loading="_get(InstanceSourceDetails, 'saving')"
            :disabled="_get(InstanceSourceDetails, 'data.preactivated')"
            @click="submitForm">
            <span v-if="_get(InstanceSourceDetails, 'data.preactivated')">{{ $t('label.preactivated') }}</span>
            <span v-else-if="_get(InstanceSourceDetails, 'data.active')">{{ $t('label.deactivate') }}</span>
            <span v-else>{{ $t('label.activate') }}</span>
          </el-button>
        </template>

        <template v-else-if="_get(InstanceSourceDetails, 'data.SourceType.code') === 'premium'" class="footer-row">
          <el-button
               size="small"
               type="nuttrema-orange"
              :disabled="_get(InstanceSourceDetails, 'data.active')">
             {{ $t('label.buy_premium_source') }}
          </el-button>
        </template>

        <el-button
           type="text"
           size="small"
          @click="cancel">
          {{ $t('label.cancel') }}
        </el-button>
      </nav>
    </template>

  </nuttrema-layout-form-standard>
</template>

<script>
import { get } from 'lodash';

import NuttremaLayoutFormStandard from 'components/ui/layout/nuttrema-layout-form-standard';

export default {
  name: 'form-instance-source-details',
  props: {
    InstanceSourceDetails: {
      required: true,
      default: null,
    },
  },
  components: {
    NuttremaLayoutFormStandard,
  },
  data() {
    return {
      formData: {},
      activeName: ['1'],
    };
  },
  methods: {
    submitForm() {
      const action = get(this.InstanceSourceDetails, 'data.active') ? 'deactivate' : 'activate';
      this.$emit('submit', action);
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~styles/component/nuttrema_list_global_style';

  .el-collapse {
    border-top: none;
    border-bottom: none;

    /deep/ .el-collapse-item {
      .el-collapse-item__header {
        background-color: transparent;
      }
      .el-collapse-item__wrap {
        background-color: transparent;
      }
      &:last-child {
        .el-collapse-item__header {
          border-bottom: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/instance/sources/details/form-instance-source-details.vue